// extracted by mini-css-extract-plugin
export var animationContainer = "_in-0";
export var asteriskIcon = "_in-8";
export var conversationLeftSection = "_in-4";
export var conversationListItem = "_in-3";
export var conversationMiddleSection = "_in-5";
export var conversationRightSection = "_in-6";
export var detailsContent = "_in-1";
export var listContainer = "_in-7";
export var modalContent = "_in-2";